// extracted by mini-css-extract-plugin
module.exports = {"button":"_89b4965636--button--bYw8s","icon":"_89b4965636--icon--VAZL9"};